import registerBoard from '../../../common/boards/index';
import presentationalComponent from './Board';
import containerComponent from './BoardContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerBoard({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.COLOR, TOOLS.ICON],
        selectedTools: [TOOLBAR_TOOLS.COLOR, TOOLBAR_TOOLS.ICON, ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT],
        tooltip: isApple ? '⌃⌘B' : 'Ctrl+Alt+B',
    });
